"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Check_1 = __importDefault(require("@mui/icons-material/Check"));
const DoNotDisturb_1 = __importDefault(require("@mui/icons-material/DoNotDisturb"));
const FilterTiltShift_1 = __importDefault(require("@mui/icons-material/FilterTiltShift"));
const Timeline_1 = __importDefault(require("@mui/icons-material/Timeline"));
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const classnames_1 = __importDefault(require("classnames"));
const dayjs_1 = __importDefault(require("dayjs"));
const relativeTime_1 = __importDefault(require("dayjs/plugin/relativeTime"));
const lodash_1 = __importDefault(require("lodash"));
const react_router_1 = require("react-router");
const react_use_1 = require("react-use");
const appConstants_1 = require("../../../../constants/appConstants");
const muiMenuItemOverrides_1 = require("../../../../material-ui-theme/components/muiMenuItemOverrides");
const useFormattedDateLocale_1 = require("../../../../utils/useFormattedDateLocale");
const zustandStore_1 = require("../../../../zustandStore");
dayjs_1.default.extend(relativeTime_1.default);
const lexico = new lexico_1.default();
function getRequestStatusIcon(status) {
    switch (status) {
        case 'approved': {
            return (0, jsx_runtime_1.jsx)(Check_1.default, { "ts-variant": "requestStatusIcon", className: status });
        }
        case 'pending': {
            return (0, jsx_runtime_1.jsx)(Timeline_1.default, { "ts-variant": "requestStatusIcon", className: status });
        }
        case 'error':
        case 'declined': {
            return (0, jsx_runtime_1.jsx)(DoNotDisturb_1.default, { "ts-variant": "requestStatusIcon", className: status });
        }
        default: {
            return (0, jsx_runtime_1.jsx)(FilterTiltShift_1.default, { "ts-variant": "requestStatusIcon", className: status });
        }
    }
}
const getStatusLabel = (state) => lodash_1.default.get(appConstants_1.requestConstants.status, state.toLowerCase(), appConstants_1.requestConstants.status.default).toLowerCase();
const RequestMenuItem = ({ request }) => {
    const date = (0, useFormattedDateLocale_1.useFormattedDateLocale)(request.lastEdit);
    const statusLabel = getStatusLabel(request.state);
    const { requestId } = (0, react_router_1.useParams)();
    const isMobileWidth = (0, react_use_1.useMedia)('(max-width: 650px)');
    const { openSideMenuOnDesktopView, openSideMenuOnMobileView } = (0, zustandStore_1.useZustand)();
    const navigate = (0, react_router_1.useNavigate)();
    return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { "data-testid": "sideMenu-request-menu-item", "ts-variant": "sideMenuPanelOption", className: (0, classnames_1.default)({
            [`${muiMenuItemOverrides_1.hasUnreadMessagesClassName}`]: request.unread && requestId !== request.requestId,
            active: requestId === request.requestId,
        }), onClick: () => {
            void navigate(`/requests/${request.requestId}`);
            if (isMobileWidth) {
                openSideMenuOnDesktopView(false);
                openSideMenuOnMobileView(false);
            }
        }, children: (0, jsx_runtime_1.jsxs)(material_1.Link, { "ts-variant": "requestMenuItemLink", children: [getRequestStatusIcon(statusLabel), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "span", "ts-variant": "myRequestSpan", sx: {
                        display: 'inline',
                    }, children: request.title || lexico.tr('New request') }), (0, jsx_runtime_1.jsx)(material_1.Typography, { title: date, "ts-variant": "myRequestSecondaySpan", children: (0, dayjs_1.default)(request.lastEdit).fromNow() })] }) }));
};
exports.default = RequestMenuItem;
